import { InjectionToken, Injectable, Inject, defineInjectable, inject, Directive, TemplateRef, ViewContainerRef, ChangeDetectorRef, NgModule } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'rxjs';
const AD_BLOCK_LOADER = new InjectionToken('fs.ab.loader');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AdBlockService {
    /**
     * @param {?} _loader
     */
    constructor(_loader) {
        this._loader = _loader;
        this.isAnAdBlockerActive = (/**
         * @return {?}
         */
        () => this._loader);
    }
}
AdBlockService.ɵfac = function AdBlockService_Factory(t) { return new (t || AdBlockService)(ɵngcc0.ɵɵinject(AD_BLOCK_LOADER)); };
AdBlockService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AdBlockService, factory: AdBlockService.ɵfac, providedIn: 'root' });
/** @nocollapse */
AdBlockService.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [AD_BLOCK_LOADER,] }] }
];
/** @nocollapse */ AdBlockService.ngInjectableDef = defineInjectable({ factory: function AdBlockService_Factory() { return new AdBlockService(inject(AD_BLOCK_LOADER)); }, token: AdBlockService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AdBlockService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.Observable, decorators: [{
                type: Inject,
                args: [AD_BLOCK_LOADER]
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class FloAdBlockDirective {
    /**
     * @param {?} tr
     * @param {?} vc
     * @param {?} ads
     * @param {?} cd
     */
    constructor(tr, vc, ads, cd) {
        this.tr = tr;
        this.vc = vc;
        this.ads = ads;
        this.cd = cd;
        this.ngOnDestroy$ = new Subject();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.ads.isAnAdBlockerActive()
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((/**
         * @param {?} isActive
         * @return {?}
         */
        isActive => {
            if (isActive) {
                if (this.showWhenAdBlocked) {
                    this.vc.createEmbeddedView(this.tr);
                }
                else {
                    this.vc.clear();
                }
            }
            else {
                if (this.showWhenAdBlocked) {
                    this.vc.clear();
                }
                else {
                    this.vc.createEmbeddedView(this.tr);
                }
            }
            this.cd.detectChanges();
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
FloAdBlockDirective.ɵfac = function FloAdBlockDirective_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
FloAdBlockDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloAdBlockDirective });

/** @type {?} */
const IF_BLOCKED_SELECTOR = 'floIfAdBlocked';
/** @type {?} */
const IF_NOT_BLOCKED_SELECTOR = 'floIfNotAdBlocked';
class FloIfAdBlockedDirective extends FloAdBlockDirective {
    /**
     * @param {?} tr
     * @param {?} vc
     * @param {?} ads
     * @param {?} cd
     */
    constructor(tr, vc, ads, cd) {
        super(tr, vc, ads, cd);
        this.tr = tr;
        this.vc = vc;
        this.ads = ads;
        this.cd = cd;
        this.elmInputKey = IF_BLOCKED_SELECTOR;
        this.showWhenAdBlocked = true;
    }
}
FloIfAdBlockedDirective.ɵfac = function FloIfAdBlockedDirective_Factory(t) { return new (t || FloIfAdBlockedDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(AdBlockService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
FloIfAdBlockedDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloIfAdBlockedDirective, selectors: [["", "floIfAdBlocked", ""]], inputs: { floIfAdBlocked: "floIfAdBlocked" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
FloIfAdBlockedDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: AdBlockService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloIfAdBlockedDirective, [{
        type: Directive,
        args: [{
                selector: `[${IF_BLOCKED_SELECTOR}]`,
                inputs: [IF_BLOCKED_SELECTOR]
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: AdBlockService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
class FloIfNotAdBlockedDirective extends FloAdBlockDirective {
    /**
     * @param {?} tr
     * @param {?} vc
     * @param {?} ads
     * @param {?} cd
     */
    constructor(tr, vc, ads, cd) {
        super(tr, vc, ads, cd);
        this.tr = tr;
        this.vc = vc;
        this.ads = ads;
        this.cd = cd;
        this.elmInputKey = IF_NOT_BLOCKED_SELECTOR;
        this.showWhenAdBlocked = false;
    }
}
FloIfNotAdBlockedDirective.ɵfac = function FloIfNotAdBlockedDirective_Factory(t) { return new (t || FloIfNotAdBlockedDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(AdBlockService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
FloIfNotAdBlockedDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FloIfNotAdBlockedDirective, selectors: [["", "floIfNotAdBlocked", ""]], inputs: { floIfNotAdBlocked: "floIfNotAdBlocked" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
FloIfNotAdBlockedDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: AdBlockService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloIfNotAdBlockedDirective, [{
        type: Directive,
        args: [{
                selector: `[${IF_NOT_BLOCKED_SELECTOR}]`,
                inputs: [IF_NOT_BLOCKED_SELECTOR]
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: AdBlockService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FloAdBlockModule {
}
FloAdBlockModule.ɵfac = function FloAdBlockModule_Factory(t) { return new (t || FloAdBlockModule)(); };
FloAdBlockModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FloAdBlockModule });
FloAdBlockModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [AdBlockService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloAdBlockModule, [{
        type: NgModule,
        args: [{
                providers: [AdBlockService],
                declarations: [FloIfAdBlockedDirective, FloIfNotAdBlockedDirective],
                exports: [FloIfAdBlockedDirective, FloIfNotAdBlockedDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FloAdBlockModule, { declarations: [FloIfAdBlockedDirective, FloIfNotAdBlockedDirective], exports: [FloIfAdBlockedDirective, FloIfNotAdBlockedDirective] }); })();

export { AD_BLOCK_LOADER, AdBlockService, FloAdBlockDirective, FloAdBlockModule, FloIfAdBlockedDirective, FloIfNotAdBlockedDirective };

